// src/components/Validations/ValidationsPage.jsx
// Updated by Claude on 2025-11-16 - Replaced with BusinessRulesBuilder
// Updated by Claude on 2025-12-28 - Added returnUrl navigation support
// Purpose: Business Rules & Validations management page for app-specific configurations

import React from 'react';
import { useSearchParams } from 'react-router-dom';
import BusinessRulesBuilder from './BusinessRulesBuilder';
import { createLogger } from '../../utils/logger';

const logger = createLogger("src/components/Validations/ValidationsPage.jsx");

const ValidationsPage = () => {
  logger.entry("ValidationsPage", "Component mounted");

  const [searchParams] = useSearchParams();
  const appNameFromUrl = searchParams.get('app'); // Get app from URL parameter

  // BusinessRulesBuilder now handles its own navigation, so we just pass the app name
  return (
    <BusinessRulesBuilder appName={appNameFromUrl} dbName="jayram" />
  );
};

export default ValidationsPage;
